import { Navigate, Outlet } from "react-router-dom";

import { ScreenLayout } from "@/app/components/layouts";
import { ROUTES } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { LiveSessionNotificationBar } from "@/features/coaching/components";

export const CoachingRoutesWrapper = () => {
  const canAccessActiveWLFeatures = usePortalUserStore(
    (state) => state.canAccessActiveWLFeatures,
  );

  if (!canAccessActiveWLFeatures) {
    return <Navigate to={ROUTES.BASE} />;
  }

  return (
    <ScreenLayout className="gap-6">
      <LiveSessionNotificationBar />
      {/* {firstOngoingSession ? (
        <LiveSessionNotificationBar session={firstOngoingSession} />
      ) : (
        <SeshNotificationBar />
      )} */}

      <Outlet />
    </ScreenLayout>
  );
};
